import { useQuery } from 'react-query';
import ProtocolService from 'App/services/ProtocolService';

function useFetchProtocolTriggers(protocolId, params) {
    return useQuery(
        ['protocols', protocolId, 'triggers', JSON.stringify(params)],
        () => ProtocolService.getTriggers(protocolId, params),
        { retry: false, refetchInterval: false, refetchOnWindowFocus: false, enabled: !!protocolId }
    );
}

export default useFetchProtocolTriggers;
